import {
  getExecutionEventsTimeInOutFieldText,
  getInvalidLoadValueText,
  getValidationExecutionEventsTimeOutAcrossDayEndText,
  getValidationExecutionEventsTimeOutOverlappingText,
  getValidationPodNotes,
} from './intl'
import { ExecutionEventsFormValues, ExecutionEventsValidation } from './typings'

const POD_NOTES_MAX_LENGTH = 512

export const validateForm =
  (workingDayStartSec: number) =>
  (formValues: ExecutionEventsFormValues): ExecutionEventsValidation => {
    const { timeInSec, timeOutSec, dynamicLoads, formPods } = formValues

    const validation: ExecutionEventsValidation = {}

    if (timeInSec >= 0 && timeOutSec >= 0) {
      if (
        ((timeInSec < workingDayStartSec && timeOutSec <= workingDayStartSec) ||
          (timeInSec > workingDayStartSec && timeOutSec >= workingDayStartSec)) &&
        timeOutSec < timeInSec
      ) {
        validation.timeInOut = getValidationExecutionEventsTimeOutOverlappingText()
        validation.timeOutSec = ' '
      }

      if (
        workingDayStartSec > 0 &&
        timeInSec <= workingDayStartSec &&
        timeOutSec > workingDayStartSec
      ) {
        validation.timeInOut = getValidationExecutionEventsTimeOutAcrossDayEndText()
        validation.timeOutSec = ' '
      }
    }

    Object.entries(dynamicLoads ?? {}).reduce((acc, [key, value]) => {
      if (value.disabled) return acc

      if (typeof value.value !== 'number' || value.value < 0) {
        acc[key] = getInvalidLoadValueText()
      }
      return acc
    }, validation)

    if (formPods?.note?.length > POD_NOTES_MAX_LENGTH) {
      if (!validation.formPods) {
        validation.formPods = {}
      }

      validation.formPods.note = getValidationPodNotes(POD_NOTES_MAX_LENGTH)
    }

    return validation
  }

export const getFieldsWithError = (errors: ExecutionEventsValidation): string[] => {
  const fieldsWithError: string[] = []

  if (errors.timeInOut) {
    fieldsWithError.push(getExecutionEventsTimeInOutFieldText())
  }

  return fieldsWithError
}
